import throttle from 'lodash/throttle';
import React, {
	useEffect,useState
} from 'react';

const useScrollPosition = () => {
	if (typeof window === 'undefined') return 500;

	// Store the state
	const [scrollPos, setScrollPos] = useState(window.pageYOffset);

	// On Scroll
	const onScroll = () => {
		setScrollPos(window.pageYOffset);
	};

	// Add and remove the window listener
	useEffect(() => {
		window.addEventListener('scroll',
			throttle(onScroll,
				400));
		return () => {
			window.removeEventListener('scroll',
				throttle(onScroll,
					400));
		};
	});

	return scrollPos;
};

export default useScrollPosition;
